<script setup lang="ts">
defineProps({
    text: {
        type: String,
        required: true
    }
})

const emits = defineEmits(['close'])
</script>

<template>
    <div
        class="z-10 relative w-screen h-screen flex justify-center items-center font-inter"
    >
        <span
            class="bg-black opacity-40 h-screen w-screen absolute"
            @click="emits('close')"
        />
        <div
            class="bg-white shadow-global-1 rounded-xl z-10 w-1/2 max-w-md max-h-screen overflow-auto min-w-300 p-4"
        >
            <div class="flex flex-col gap-2 mb-6">
                <h4
                    class="text-center font-bold text-twenty-two leading-6 tracking-light text-gray-l-900"
                >
                    <span>{{ $t('word.warning') }}</span>
                </h4>
                <span
                    class="text-center font-normal text-seventeen-exploitation leading-5 tracking-light text-gray-l-700 break-words"
                >
                    {{ text }}
                </span>
            </div>
            <div class="flex flex-col justify-center">
                <ChargemapB2CButton
                    id="chargemap-button"
                    type="tertiary"
                    size="medium"
                    variant="black"
                    @click="emits('close')"
                >
                    {{ $t('ok') }}
                </ChargemapB2CButton>
            </div>
        </div>
    </div>
</template>
